document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.hm-cat-card');

  cards.forEach((card, index) => {
    if (index === 0) {
      card.style.transform = 'translateX(-50px)'; /* aur kam kiya */
      card.style.opacity = '0';
    } else if (index === 1) {
      card.style.transform = 'translateY(50px)';
      card.style.opacity = '0';
    } else if (index === 2) {
      card.style.transform = 'translateX(50px)'; /* aur kam kiya */
      card.style.opacity = '0';
    }
    card.style.transition = 'transform 0.8s ease, opacity 0.8s ease';
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.transform = 'translate(0, 0)';
        entry.target.style.opacity = '1';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  cards.forEach(card => observer.observe(card));
});
